<img *ngIf="isImage;else noImage" width="50"  height="50"  [src]="imagePath" (click)="openImage()">
<ng-template #noImage>
    <span>No Image</span>
</ng-template>